"use strict";
/**
 * @module Services.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Authenticator response type
 */
var TypeCode;
(function (TypeCode) {
    TypeCode[TypeCode["DENY"] = 0] = "DENY";
    TypeCode[TypeCode["ABSTAIN"] = 1] = "ABSTAIN";
    TypeCode[TypeCode["ALLOW"] = 2] = "ALLOW";
})(TypeCode = exports.TypeCode || (exports.TypeCode = {}));
/**
 * Server response from a AUTHENTICATION request.
 */
var AuthenticatorResponse = /** @class */ (function () {
    /**
     * Create a new AuthenticatorResponse instance
     *
     * @param type  the authenticator response type
     * @param properties  the session properties
     */
    function AuthenticatorResponse(type, properties) {
        this.type = type;
        this.properties = properties;
    }
    return AuthenticatorResponse;
}());
exports.AuthenticatorResponse = AuthenticatorResponse;
/**
 * An AuthenticatorResponse that denies authenticator
 */
exports.DENY = Object.freeze(new AuthenticatorResponse(TypeCode.DENY));
/**
 * An AuthenticatorResponse that abstains
 */
exports.ABSTAIN = Object.freeze(new AuthenticatorResponse(TypeCode.ABSTAIN));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-response.js
// module id = 566
// module chunks = 1